import moment from "moment";

export const curSym = "$";
// Set token
export const setToken = (panel, token) => {
  const key = `${panel}_token_nuvio`;
  if (key) localStorage.setItem(key, token);
};

// Get token
export const getToken = (panel) => {
  const key = `${panel}_token_nuvio`;
  const token = localStorage.getItem(key);

  if (token) return token;

  // fallback priority
  return (
    localStorage.getItem("freelancer_token_nuvio") ||
    localStorage.getItem("coach_token_nuvio")
  );
};

const CREATEBOOTCAMP_KEY = "createBootCampFormData";
const WEBINAR_KEY = "WebinarFormData";
const STORAGE_KEY = "coachSignupFormData";
const editBootcampKey = "isEditBootcamp";
const FREELANCER_KEY = "freelancerSignupFormData";
const HIRE_TALENT_KEY = "hireTalentSignupFormData";

export const setBootcampModalVal = (val) => {
  localStorage.setItem(editBootcampKey, val);
};

export const getBootcampModalVal = () => {
  return localStorage.getItem(editBootcampKey) || false;
};

export const getFormData = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved
    ? JSON.parse(saved)
    : {
      step1: { full_name: "", email: "", phone_number: "" },
      step2: { category_id: "", year_of_experience: "", format: "" },
      step3: {
        bio: "",
        reason: "",
        profile_image: null,
        cv: [],
        certificate: [],
      },
    };
};

export const updateFormData = (stepKey, values) => {
  const existing = getFormData();
  const updated = { ...existing, [stepKey]: values };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
};

export const clearFormData = () => {
  localStorage.removeItem(STORAGE_KEY);
};

let memoryCache = {};

const sanitizeForLocalStorage = (data) => {
  if (Array.isArray(data)) {
    return data.map(sanitizeForLocalStorage);
  }
  if (data && typeof data === "object") {
    const result = {};
    for (const key in data) {
      const value = data[key];
      if (value instanceof File || value instanceof Blob) {
        // Keep in memory, don't put in localStorage
        if (!memoryCache[CREATEBOOTCAMP_KEY])
          memoryCache[CREATEBOOTCAMP_KEY] = {};
        if (!memoryCache[CREATEBOOTCAMP_KEY][key])
          memoryCache[CREATEBOOTCAMP_KEY][key] = value;
        result[key] = null; // placeholder only
      } else if (typeof value === "object" && value !== null) {
        result[key] = sanitizeForLocalStorage(value);
      } else {
        result[key] = value;
      }
    }
    return result;
  }
  return data;
};

export const getBootCampFormData = () => {
  const saved = localStorage.getItem(CREATEBOOTCAMP_KEY);
  const base = saved
    ? JSON.parse(saved)
    : {
      step1: {
        header_title: "",
        start_date: "",
        end_date: "",
        location: "",
        header_description: "",
      },
      step2: { bootCampData: "", dayData: [] },
      step3: {
        points: [{ value: "" }],
        footer_title: "",
        status: "Draft",
        brochure: null,
        footer_image: null,
        footer_sub_title: "",
        footer_description: "",
        header_image: null,
        brochure_color: "#1e4457",
        footer_color: "#023047",
      },
    };

  // 🔹 Merge back in-memory images (so step2 doesn’t lose speaker images)
  const cache = memoryCache[CREATEBOOTCAMP_KEY];
  if (cache) {
    const restoreImages = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(restoreImages);
      }
      if (obj && typeof obj === "object") {
        const result = { ...obj };
        for (const key in result) {
          if (result[key] === null && cache[key]) {
            result[key] = cache[key];
          } else if (typeof result[key] === "object") {
            result[key] = restoreImages(result[key]);
          }
        }
        return result;
      }
      return obj;
    };
    return restoreImages(base);
  }

  return base;
};

export const updateBootCampFormData = (stepKey, values) => {
  const existing = getBootCampFormData();
  const sanitizedValues = sanitizeForLocalStorage(values);
  const updated = { ...existing, [stepKey]: sanitizedValues };
  localStorage.setItem(CREATEBOOTCAMP_KEY, JSON.stringify(updated));
};

export const clearBootCampFormData = () => {
  localStorage.removeItem(CREATEBOOTCAMP_KEY);
  memoryCache = {}; // also clear temporary cache
};

// Webinar :
export const getWebFormData = () => {
  const saved = localStorage.getItem(WEBINAR_KEY);
  return saved
    ? JSON.parse(saved)
    : {
      step0: { speakerType: "" },
      step1: {
        header: "",
        title: "",
        description: "",
        dateTime: "",
        language: "",
        duration: "",
      },
      step6: { section1_image: null },
    };
};

export const updateWebFormData = (stepKey, values) => {
  const existing = getWebFormData();
  const updated = { ...existing, [stepKey]: values };
  localStorage.setItem(WEBINAR_KEY, JSON.stringify(updated));
};

export const clearWebFormData = () => {
  localStorage.removeItem(WEBINAR_KEY);
};

// Set Profile
export const setProfile = (panel, profile) => {
  const key = `${panel}_profile_nuvio`;
  localStorage.setItem(key, JSON.stringify(profile));
};

// Get Profile
export const getProfile = (panel) => {
  if (!panel) return;
  const key = `${panel}_profile_nuvio`;
  const stored = localStorage.getItem(key);

  if (!stored) return {};

  const parsed = JSON.parse(stored || "{}");
  return parsed;
};

// Date View Format
export const pipViewDate = (date) => {
  if (!date) return;
  return moment(date).format("DD-MM-YYYY");
};

export const pipViewDate3 = (date) => {
  if (!date) return;
  return moment(date).format("YYYY-MM-DD");
};

export const pipViewDate2 = (date) => {
  if (!date) return;
  return moment(date).format("DD-MMM-YYYY");
};


// get saved profile from backend (localStorage)
const getLocalProfile = () => {
  try {
    return JSON.parse(localStorage.getItem(PROFILE_KEY)) || {};
  } catch {
    return {};
  }
};

export const clearFreelancerFormData = () => {
  localStorage.removeItem(FREELANCER_KEY);
};

export const getHireTalentFormData = () => {
  try {
    return JSON.parse(localStorage.getItem(HIRE_TALENT_KEY)) || {};
  } catch {
    return {};
  }
};

export const updateHireTalentFormData = (values) => {
  localStorage.setItem(HIRE_TALENT_KEY, JSON.stringify(values));
};

export const clearHireTalentFormData = () => {
  localStorage.removeItem(HIRE_TALENT_KEY);
};

const PROFILE_KEY = "freelancer_profile_nuvio";

export const getFreelancerFormData = () => {
  let tempData = {};
  const localProfile = getLocalProfile() || {};
  let backend = localProfile?.open_talent || {};

  // Load temporary saved form
  try {
    tempData = JSON.parse(localStorage.getItem(FREELANCER_KEY)) || {};
  } catch {
    tempData = {};
  }

  // RETURN MERGED DATA
  const baseProfileStep1 = {
    phone_number: backend?.phone_number || localProfile?.phone_number || "",
    country: backend?.country || "",
    city: backend?.city || "",
    linkedin_profile: backend?.linkedin_profile || "",
    portfolio_website: backend?.portfolio_website || "",
    bio: backend?.bio || "",
  };

  const baseProfileStep2 = {
    primary_role: backend?.primary_role || "",
    years_of_experience: backend?.years_of_experience || "",
    key_skills: backend?.key_skills ? backend.key_skills.split(",") : [],
    tools: backend?.tools ? backend.tools.split(",") : [],
    availability: backend?.availability
      ? backend.availability.split(",").map((item) => item.trim()).filter(Boolean)
      : [],
    hourly_rate: backend?.hourly_rate || "",
    preferred_project_type: backend?.preferred_project_type
      ? backend.preferred_project_type.split(",")
      : [],
  };

  const baseProfileStep3 = {
    experiences: backend?.experiences || [],
    portfolio_links: backend?.portfolio_links || [""],
    work_samples: backend?.work_samples || [],
  };

  const baseProfileStep4 = {
    join_reason: backend?.join_reason || "",
    interested_clients: backend?.interested_clients || "",
    heard_about: backend?.heard_about || "",
    consent_accuracy: false,
    consent_contact: false,
  };

  return {
    step1: tempData.step1 || {},
    profileStep1: { ...baseProfileStep1, ...(tempData.profileStep1 || {}) },
    profileStep2: { ...baseProfileStep2, ...(tempData.profileStep2 || {}) },
    profileStep3: { ...baseProfileStep3, ...(tempData.profileStep3 || {}) },
    profileStep4: { ...baseProfileStep4, ...(tempData.profileStep4 || {}) },
  };
};

export const updateFreelancerFormData = (stepKey, values) => {
  const existing = getFreelancerFormData();

  // sanitize to avoid File objects
  const sanitized = JSON.parse(
    JSON.stringify(values, (key, value) => {
      if (value instanceof File) {
        return {
          name: value.name,
          type: value.type,
          preview: URL.createObjectURL(value),
        };
      }
      return value;
    })
  );

  const updated = { ...existing, [stepKey]: sanitized };

  localStorage.setItem(FREELANCER_KEY, JSON.stringify(updated));
};

export const toUTCParts = (date, time) => {
  if (!date || !time) return {};

  // Local date-time → Date object
  const localDateTime = new Date(`${date}T${time}:00`);

  const iso = localDateTime.toISOString(); // UTC

  return {
    utcDateTime: iso, // "2026-01-07T09:00:00.000Z"
    utcDate: iso.split("T")[0], // "2026-01-07"
    utcTime: iso.split("T")[1].slice(0, 5), // "09:00"
  };
};

export const utcToLocalParts = (utcISO) => {
  if (!utcISO) return { date: "", time: "" };

  const d = new Date(utcISO);

  return {
    date: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`,
    time: `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`,
  };
};


// Convert LOCAL date + time → UTC date & time
export const localToUTCDateTimeParts = (date, time) => {
  if (!date || !time) {
    return { utcDate: "", utcTime: "" };
  }

  // Treat input as LOCAL datetime
  const localDateTime = new Date(`${date}T${time}:00`);

  const iso = localDateTime.toISOString(); // UTC

  return {
    utcDate: iso.split("T")[0],           // YYYY-MM-DD
    utcTime: iso.split("T")[1].slice(0, 5), // HH:mm
  };
};

// Convert UTC date + time → LOCAL (for edit/view if ever needed)
export const utcToLocalDateTimeParts = (utcDate, utcTime) => {
  console.log({ utcDate, utcTime })
  if (!utcDate || !utcTime) {
    return { date: "", time: "" };
  }

  const utc = new Date(`${utcDate}T${utcTime}:00Z`);

  return {
    date: `${utc.getFullYear()}-${String(utc.getMonth() + 1).padStart(2, "0")}-${String(utc.getDate()).padStart(2, "0")}`,
    time: `${String(utc.getHours()).padStart(2, "0")}:${String(utc.getMinutes()).padStart(2, "0")}`,
  };
};


export function pip_TimeAgo(timestamp) {
  if (!timestamp) return "";

  const now = new Date();
  const past = new Date(timestamp);
  let diffMs = now - past;

  // If timestamp is in future
  if (diffMs < 0) diffMs = 0;

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) {
    return "Just now";
  }

  if (minutes < 60) {
    return `${minutes} min${minutes > 1 ? "s" : ""} ago`;
  }

  if (hours < 24) {
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  }

  if (days === 1) {
    return "Yesterday";
  }

  if (days < 30) {
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }

  if (months < 12) {
    return `${months} month${months > 1 ? "s" : ""} ago`;
  }

  return `${years} year${years > 1 ? "s" : ""} ago`;
}

export const formatTime = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDateLabel = (dateStr) => {
  const date = new Date(dateStr);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const isSameDay = (d1, d2) =>
    d1.toDateString() === d2.toDateString();

  if (isSameDay(date, today)) return "Today";
  if (isSameDay(date, yesterday)) return "Yesterday";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


export const getFileCategory = (fileType = "") => {
  if (fileType.startsWith("image")) return "image";
  if (fileType.startsWith("video")) return "video";
  return "file"; // zip, pdf, doc, etc
};
